import * as React from 'react';
import { getBasePath } from '../../utils/browser';
import SNEColorButton from './SNEColorButton';

interface IconButtonProps {
  readonly onClick?: () => void;
  readonly colorIndex: number;
  readonly href?: string;
  readonly style?: React.CSSProperties;
  readonly containerStyle?: React.CSSProperties;
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly active?: boolean;
  readonly disabled?: boolean;
  readonly margin?: boolean;
}

const buttonContainerStyle: React.CSSProperties = {
  width: '30px',
  height: '30px',
};

const activeFrameImageStyle: React.CSSProperties = {
  position: 'relative',
  height: '48px',
  width: '48px',
  padding: '9px',
  pointerEvents: 'none',
  boxSizing: 'border-box',
  zIndex: 1,
  top: '-9px',
  left: '-9px',
};

const SNEColorSelectButton: React.SFC<IconButtonProps> = React.memo((props) => {
  const {
    style, active, disabled, margin, colorIndex, containerStyle,
    onClick, title, href, ariaLabel,
  } = props;

  const buttonContainerAdditionalStyle: React.CSSProperties = {};
  let frameImageStyle: React.CSSProperties = {};

  if (margin !== false) {
    buttonContainerAdditionalStyle.margin = '2px';
  }

  if (active) {
    const baseDir = getBasePath();
    const imgSrc = `${baseDir}/images/setting-popup/frame/select_frame_bw_color_02.png`;
    frameImageStyle =
      {
        ...activeFrameImageStyle,
        backgroundImage: `url(${imgSrc})`,
        backgroundSize: 'contain',
      };
  }

  return (
    <div style={{ ...buttonContainerStyle, ...buttonContainerAdditionalStyle, ...containerStyle }} >
      <div style={{ ...frameImageStyle }} >
        <SNEColorButton
          colorIndex={colorIndex}
          onClick={onClick}
          margin={false}
          active={false}
          style={ style }
          disabled={disabled}
          title={title}
          href={href}
          ariaLabel={ariaLabel}
        />
      </div>
    </div>
  );
});

export default SNEColorSelectButton;
